export class OfflineError extends Error {
  constructor(msg = 'Offline') {
    super(msg);
  }
}
